import React, { useCallback, useState, useEffect } from 'react';
import { Grid } from '@material-ui/core';
import clsx from 'clsx';

import { QuestionCircleIcon } from '../../icon/solid';
import { StudioControlStyles } from '../styles';
import { Button } from '../..';

import StudioToolTip from './StudioToolTip';


const HelpAction = () => {
  const classes = StudioControlStyles();
  const [isActive, setIsActive] = useState(false);

  const helpHandler = useCallback(() => {
    if (window.Lighthouse) {
      if (isActive) {
        window.Lighthouse.hide();
      } else {
        window.Lighthouse.show();
      }
    }
  }, [isActive]);

  useEffect(() => {
    if (window.hdlh) {
      if (typeof window.hdlh.isOpen === 'boolean' && window.hdlh.isOpen !== isActive) {
        setIsActive(window.hdlh.isOpen);
      }
    }
  }, [isActive, setIsActive]);

  useEffect(() => {
    if (window.hdlh) {
      const defaultShow = window.hdlh.onShow;
      const defaultHide = window.hdlh.onHide;
      window.hdlh.onShow = () => {
        if (defaultShow) {
          defaultShow();
        }
        setIsActive(true);
      };
      window.hdlh.onHide = () => {
        if (defaultHide) {
          defaultHide();
        }
        setIsActive(false);
      };
      return () => {
        if (window.hdlh) {
          window.hdlh.onShow = defaultShow;
          window.hdlh.onHide = defaultHide;
        }
      };
    }
  }, [setIsActive]);

  return (
    <Grid item >
      <StudioToolTip title="Help">
        <Button
          onClick={helpHandler}
          style={{ border: 'unset' }}
          className={clsx(classes.button, classes.circleButton)}
          classes={{
            label: classes.circleButton,
          }}
        >
          <QuestionCircleIcon className={classes.icon} />
        </Button>
      </StudioToolTip>
    </Grid>
  );
};

export default HelpAction;
